import { useState, useEffect } from 'react';

import loginSplashDesktop from './images/login-splash-desktop.png';
import loginSplashTablet from './images/login-splash-tablet.png';
import loginSplashMobile from './images/login-splash-mobile.png';

import recordScreenDscribeDesktop from './images/record-page-dscribe-desktop.png';
import recordScreenDscribeTablet from './images/record-page-dscribe-tablet.png';
import recordScreenDscribeMobile from './images/record-page-dscribe-mobile.png';

import appSearchDesktop from './images/app-search-desktop.png';
import appSearchTablet from './images/app-search-tablet.png';
import appSearchMobile from './images/app-search-mobile.png';

import appDownloadDesktop from './images/app-download-desktop.png';
import appDownloadTablet from './images/app-download-tablet.png';
import appDownloadMobile from './images/app-download-mobile.png';

import loginDesktop from './images/login-save-password-desktop.png';
import loginTablet from './images/login-save-password-tablet.png';
import loginMobile from './images/login-save-password-mobile.png';

import pickAnAccountDesktop from './images/pick-an-account-desktop.png';
import pickAnAccountTablet from './images/pick-an-account-tablet.png';
import pickAnAccountMobile from './images/pick-an-account-mobile.png';

import secureloginDesktop from './images/secure-login-desktop.png';
import secureloginTablet from './images/secure-login-tablet.png';
import secureloginMobile from './images/secure-login-mobile.png';

import enterPasswordDesktop from './images/enter-password-desktop.png';
import enterPasswordTablet from './images/enter-password-tablet.png';
import enterPasswordMobile from './images/enter-password-mobile.png';

import settingsScreenDesktop from './images/settings-desktop.png';
import settingsScreenTablet from './images/settings-tablet.png';
import settingsScreenMobile from './images/settings-mobile.png';

import menuDesktop from './images/dscribe-menu-desktop.png';
import menuTablet from './images/dscribe-menu-tablet.png';
import menuMobile from './images/dscribe-menu-mobile.png';

import schedulesScreenDesktop from './images/dscribe-schedules-desktop.png';
import schedulesScreenTablet from './images/dscribe-schedules-tablet.png';
import schedulesScreenMobile from './images/dscribe-schedules-mobile.png';

import calendarAndroidDesktop from './images/dscribe-calendar-android-desktop.png';
import calendarAndroidTablet from './images/dscribe-calendar-android-tablet.png';
import calendarAndroidMobile from './images/dscribe-calendar-android-mobile.png';

import calendariOSDesktop from './images/dscribe-calendar-ios-desktop.png';
import calendariOSTablet from './images/dscribe-calendar-ios-tablet.png';
import calendariOSMobile from './images/dscribe-calendar-ios-mobile.png';

import markAsDictatedDesktop from './images/mark-as-dictated-desktop.png';
import markAsDictatedTablet from './images/mark-as-dictated-tablet.png';
import markAsDictatedMobile from './images/mark-as-dictated-mobile.png';

import dictationScreenDesktop from './images/dictation-screen-desktop.png';
import dictationScreenTablet from './images/dictation-screen-tablet.png';
import dictationScreenMobile from './images/dictation-screen-mobile.png';

import locationsScreenDesktop from './images/locations-desktop.png';
import locationsScreenTablet from './images/locations-tablet.png';
import locationsScreenMobile from './images/locations-mobile.png';

import documentTypeDesktop from './images/document-type-desktop.png';
import documentTypeTablet from './images/document-type-tablet.png';
import documentTypeMobile from './images/document-type-mobile.png';

import documentTypeDictationsDesktop from './images/document-type-dictations-desktop.png';
import documentTypeDictationsTablet from './images/document-type-dictations-tablet.png';
import documentTypeDictationsMobile from './images/document-type-dictations-mobile.png';

import playScreenDesktop from './images/play-screen-desktop.png';
import playScreenTablet from './images/play-screen-tablet.png';
import playScreenMobile from './images/play-screen-mobile.png';

import logoutScreenDesktop from './images/logout-desktop.png';
import logoutScreenTablet from './images/logout-tablet.png';
import logoutScreenMobile from './images/logout-mobile.png';

import dictationCardDesktop from './images/dictation-card-desktop.png';
import dictationCardTablet from './images/dictation-card-tablet.png';
import dictationCardMobile from './images/dictation-card-mobile.png';

import vscribeIcon from './images/vscribe-icon.png'; 

import reUploadDesktop from './images/re-upload-desktop.png';
import reUploadTablet from './images/re-upload-tablet.png';
import reUploadMobile from './images/re-upload-mobile.png';

import uploadProgressBanner from './images/upload-progress-banner.png';

import dscribeLiteModeMobile from './images/dscribe-lite-mode-mobile.png';
import dscribeLiteModeTablet from './images/dscribe-lite-mode-tablet.png';
import dscribeLiteModeDesktop from './images/dscribe-lite-mode-desktop.png';

import './Guide.css';
import { useMediaQuery } from 'react-responsive';
import { Layout } from "antd";

const DscribeGuide = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  const isDesktop = useMediaQuery({ minWidth: 1024 });

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
  <Layout>
    <div className={isMobile ? "main-content-wrapper-mobile" : "main-content-wrapper"}>
      <div className="dscribe-guide">
        {/* --- Cover Page --- */}
        <div className="guide-cover-header">
          <h1>vScribe+ Guide</h1>
        </div>
        <div className="guide-cover-image-container">
          {isMobile && (
            <img src={loginSplashMobile} alt="Login Splash" />
          )}
          {isTablet && (
            <img src={loginSplashTablet} alt="Login Splash" />
          )}
          {isDesktop && (
            <img src={loginSplashDesktop} alt="Login Splash" />
          )}
        </div>

        <div className="section-intro section-intro--reduced-margin">
          <div className="intro-text-block">
            <h2>Introduction to vScribe+</h2>
            <p>vScribe+ is a dedicated mobile application designed to make clinical dictation effortless. It streamlines your mobile experience, allowing you to capture patient encounters quickly and securely</p>
            <br />
            <h2>About the Solution</h2>
            <p>The vScribe+ platform is more than just a recorder; it is a complete document management solution for healthcare teams. It lets providers record visits, attach patient details, and send audio to TransDyne for transcription. Providers can later review dictations, manage schedules, and track the status of submissions.</p>
          </div>
          <div className="dscribe-record-image-wrapper">
            {isMobile && (
              <img src={recordScreenDscribeMobile} alt="Record Screen" className="dscribe-record-image" />
            )}
            {isTablet && (
              <img src={recordScreenDscribeTablet} alt="Record Screen" className="dscribe-record-image" />
            )}
            {isDesktop && (
              <img src={recordScreenDscribeDesktop} alt="Record Screen" className="dscribe-record-image" />
            )}
          </div>
        </div>

        <div className="section-intro">
          <div className="intro-text-block">
            <h2>Key Capabilities</h2>
          </div>
          <div className="dscribe-benefits-list">
            <div className="dscribe-benefit-item">
              <strong>Dictation</strong>
              <p>Dictate for patients on your schedule or create anonymous dictations.</p>
            </div>
            <div className="dscribe-benefit-item">
              <strong>Management</strong>
              <p>Add patients to your schedule and modify dictations as needed.</p>
            </div>
            <div className="dscribe-benefit-item">
              <strong>Upload & Review</strong>
              <p>Securely upload to TransDyne and listen to uploaded dictations.</p>
            </div>
          </div>
        </div>

        {/* --- Table of Contents --- */}
        <div className="toc-container">
          <div className="toc-header">
            <h2>Table of Contents</h2>
          </div>

          <div className="toc-content">
            <div className="toc-list">
              <ul>
                <li>
                  <span className="chapter-number">01</span>
                  <div className="chapter-content">
                    <a className="chapter-title" href="#chapter1">Chapter 1: Download and Installation</a>
                  </div>
                </li>

                <li>
                  <span className="chapter-number">02</span>
                  <div className="chapter-content">
                    <a className="chapter-title" href="#chapter2">Chapter 2: Getting Started</a>
                    <ul className="sub-list">
                      <li><a href="#2.1">2.1 Logging In</a></li>
                    </ul>
                  </div>
                </li>

                <li>
                  <span className="chapter-number">03</span>
                  <div className="chapter-content">
                    <a className="chapter-title" href="#chapter3">Chapter 3: Application Menu</a>
                  </div>
                </li>

                <li>
                  <span className="chapter-number">04</span>
                  <div className="chapter-content">
                    <a className="chapter-title" href="#chapter4">Chapter 4: Schedules Screen</a>
                    <ul className="sub-list">
                      <li><a href="#4.1">4.1 Screen Navigation</a></li>
                      <li><a href="#4.2">4.2 Schedule Status Indicators</a></li>
                      <li><a href="#4.3">4.3 Managing Schedules</a></li>
                    </ul>
                  </div>
                </li>

                <li>
                  <span className="chapter-number">05</span>
                  <div className="chapter-content">
                    <a className="chapter-title" href="#chapter5">Chapter 5: Dictations Screen</a>
                    <ul className="sub-list">
                      <li><a href="#5.1">5.1 Screen Navigation &amp; Tabs</a></li>
                      <li><a href="#5.2">5.2 The Dictation Card</a></li>
                      <li><a href="#5.3">5.3 Status Indicators</a></li>
                      <li><a href="#5.4">5.4 Troubleshooting Uploads</a></li>
                    </ul>
                  </div>
                </li>

                <li>
                  <span className="chapter-number">06</span>
                  <div className="chapter-content">
                    <a className="chapter-title" href="#chapter6">Chapter 6: Initiate Dictation for a Patient</a>
                    <ul className="sub-list">
                      <li><a href="#6.1">6.1 Starting a New Dictation</a></li>
                      <li><a href="#6.2">6.2 Creating Additional Dictations</a></li>
                      <li><a href="#6.3">6.3 Appending to a Dictation</a></li>
                    </ul>
                  </div>
                </li>

                <li>
                  <span className="chapter-number">07</span>
                  <div className="chapter-content">
                    <a className="chapter-title" href="#chapter7">Chapter 7: Recording Screen</a>
                    <ul className="sub-list">
                      <li><a href="#7.1">7.1 Patient Identification Card</a></li>
                      <li><a href="#7.2">7.2 Audio Controls</a></li>
                      <li><a href="#7.3">7.3 Finalizing the Dictation</a></li>
                      <li><a href="#7.4">7.4 Lite Mode</a></li>
                    </ul>
                  </div>
                </li>

                <li>
                  <span className="chapter-number">08</span>
                  <div className="chapter-content">
                    <a className="chapter-title" href="#chapter8">Chapter 8: Settings</a>
                    <ul className="sub-list">
                      <li><a href="#8.1">8.1 Configurations</a></li>
                      <li><a href="#8.2">8.2 Additional Information</a></li>
                    </ul>
                  </div>
                </li>

                <li>
                  <span className="chapter-number">09</span>
                  <div className="chapter-content">
                    <a className="chapter-title" href="#chapter9">Chapter 9: Logout</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Chapter 1 – Download and Installation */}
        <div className="toc-container">
          <div className='chapter-heading' id="chapter1">
            Chapter 1 – Download and Installation
          </div>
           
          <div className="chapter-content-flex">
            <div className="image-pair-container">
              <div className="image-row">
                <div className="figure-item">
                  {isMobile && (
                    <img src={appSearchMobile} className="figure-image" alt="Search Screen" />
                  )}
                  {isTablet && (
                    <img src={appSearchTablet} className="figure-image" alt="Search Screen" />
                  )}
                  {isDesktop && (
                    <img src={appSearchDesktop} className="figure-image" alt="Search Screen" />
                  )}
                  <p className="caption">SEARCH</p>
                </div>
                <div className="figure-item">
                  {isMobile && (
                    <img src={appDownloadMobile} className="figure-image" alt="Download Screen" />
                  )}
                  {isTablet && (
                    <img src={appDownloadTablet} className="figure-image" alt="Download Screen" />
                  )}
                  {isDesktop && (
                    <img src={appDownloadDesktop} className="figure-image" alt="Download Screen" />
                  )}
                  <p className="caption">DOWNLOAD</p>
                </div>
              </div>
            </div>

            <div className="chapter-text-content">
              <div className='margin-bottom-20'>
                <span className='blue-heading'>1. Open Store</span><br></br> Open Google Play Store (Android) or App Store (iOS).
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>2. Search</span><br></br> Search for "vScribe+ by TransDyne".
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>3. Install</span><br></br> Select the app, tap Install (or Get), and wait for installation to finish.
              </div>
            </div>
          </div>
        </div>

        {/* Chapter 2 – Getting Started */}
        <div className="toc-container">
          <div className='chapter-heading' id="chapter2">
            Chapter 2 – Getting Started
          </div>

          <div className='margin-bottom-20'>
            This chapter covers how to launch the application, log in with your credentials,
            and manage your password settings for faster access.
          </div>

          <div className='sub-chapter-heading' id="2.1">
            2.1 Logging In
          </div>

          <div>
            <div className='margin-bottom-20'>
              <span className='blue-heading'>1. Launch</span><br></br> Tap the vScribe+ icon on your device's home screen or application menu.
            </div>
            <div className='margin-bottom-20'>
              <span className='blue-heading'>2. Initiate Login</span><br></br> Tap the Login button on the Login screen.
            </div>
            <div className='margin-bottom-20'>
              <span className='blue-heading'>3. Select Account</span><br></br> The app will detect your status:
            </div>
            <div className='margin-bottom-20'>
              <span className='blue-heading'>4. Returning Users</span><br></br> Select your account from the "Pick an account" list. (If your account is not listed, tap Use another account).
            </div>
            <div className='margin-bottom-20'>
              <span className='blue-heading'>5. New Users</span><br></br> You will be directed to the "Secure Login" page. Enter your registered email address and tap Next.
            </div>
            <div className='margin-bottom-20'>
              <span className='blue-heading'>6. Authenticate</span><br></br> Enter your password when prompted.
            </div>
            <div className='margin-bottom-20'>
              <span className='blue-heading'>7. Access</span><br></br> Tap Sign in. Upon successful validation, the app will open the Schedules page.
            </div>
          </div>

          <div className="login-flow-images">
            {isMobile && (
              <img src={loginMobile} className="flow-image" alt="Login Screen" />
            )}
            {isTablet && (
              <img src={loginTablet} className="flow-image" alt="Login Screen" />
            )}
            {isDesktop && (
              <img src={loginDesktop} className="flow-image" alt="Login Screen" />
            )}
            {isSmallScreen ? <div className="down-arrow">&darr;</div> : <div className="flow-arrow">&rarr;</div>}
            {isMobile && (
              <img src={pickAnAccountMobile} className="flow-image" alt="Pick Account" />
            )}
            {isTablet && (
              <img src={pickAnAccountTablet} className="flow-image" alt="Pick Account" />
            )}
            {isDesktop && (
              <img src={pickAnAccountDesktop} className="flow-image" alt="Pick Account" />
            )}
            {isSmallScreen ? <div className="down-arrow">&darr;</div> : <div className="flow-arrow">&rarr;</div>}
            {isMobile && (
              <img src={secureloginMobile} className="flow-image" alt="Secure Login" />
            )}
            {isTablet && (
              <img src={secureloginTablet} className="flow-image" alt="Secure Login" />
            )}
            {isDesktop && (
              <img src={secureloginDesktop} className="flow-image" alt="Secure Login" />
            )}
            {isSmallScreen ? <div className="down-arrow">&darr;</div> : <div className="flow-arrow">&rarr;</div>}
            {isMobile && (
              <img src={enterPasswordMobile} className="flow-image" alt="Enter Password" />
            )}
            {isTablet && (
              <img src={enterPasswordTablet} className="flow-image" alt="Enter Password" />
            )}
            {isDesktop && (
              <img src={enterPasswordDesktop} className="flow-image" alt="Enter Password" />
            )}
          </div>
        </div>

        {/* Chapter 3 – Application Menu */}
        <div className="toc-container">
          <div className='chapter-heading' id="chapter3">
            Chapter 3 – Application Menu
          </div>

          <div className="chapter-content-flex">
            {isMobile && (
              <img src={menuMobile} className="chapter-image" alt="Application Menu" />
            )}
            {isTablet && (
              <img src={menuTablet} className="chapter-image" alt="Application Menu" />
            )}
            {isDesktop && (
              <img src={menuDesktop} className="chapter-image" alt="Application Menu" />
            )}

            <div className="chapter-text-content margin-top-20">
              <div>
                After logging in, the application opens to the Schedules page, which serves as the landing page. In the top-left corner of the screen, 
                you will find the Menu icon (three horizontal lines). Selecting this icon opens the main application menu.
              </div>
              <br/>
              <div>
                The application menu includes the following options:
              </div>

              <ol className='blue-list'>
                <li>dScribe</li>
                <li>User Guide</li>
                <li>Settings</li>
                <li>Logout</li>
              </ol>
            </div>
          </div>
        </div>
        

        {/* Chapter 4 – Schedules Screen */}
        <div className="toc-container">
          

          <div className="chapter-content-flex margin-bottom-40">
            <div className="chapter-text-content">
              <div className='chapter-heading' id="chapter4">
                Chapter 4 – Schedules Screen
              </div>
              <div>
                The Schedules screen is the default landing page after a successful login.
                It displays all patients scheduled for the current date of service. You can
                return to this screen at any time by selecting dScribe from the application menu.
              </div>
            </div>

            {isMobile && (
              <img src={schedulesScreenMobile} className="chapter-image" alt="Schedules Screen" />
            )}
            {isTablet && (
              <img src={schedulesScreenTablet} className="chapter-image" alt="Schedules Screen" />
            )}
            {isDesktop && (
              <img src={schedulesScreenDesktop} className="chapter-image" alt="Schedules Screen" />
            )}
          </div>

          <div className='sub-chapter-heading' id="4.1">
            4.1 Screen Navigation
          </div>

          <div className='margin-bottom-20'>
            Use the following controls to navigate your schedule and view different patient lists.
          </div>

          <div className='small-heading'>
            Tabs (Dictation Status)
          </div>

          <div className='margin-bottom-20'>
            <span className='blue-heading'>Today</span><br></br> Displays all patients scheduled for the selected date, regardless of their dictation status.
          </div>
          <div className='margin-bottom-20'>
            <span className='blue-heading'>Pending</span><br></br> Displays patients (from the current date and past dates) whose dictations have not yet been completed.
          </div>
          <div className='margin-bottom-20'>
            <span className='blue-heading'>Dictated</span><br></br> Displays patients (from the current date and past dates) whose dictations are complete.
          </div>

          <div className="tabs-demo">
            <div className="tab tab--active">Today</div>
            <div className="tab">Pending (45)</div>
            <div className="tab">Dictated</div>
          </div>

          <div className='small-heading'>
            Date Selection
          </div>

          <div className="chapter-content-flex">
            <div className="image-pair-container">
              <div className="image-row">
                <div className="figure-item">
                  {isMobile && (
                    <img src={calendariOSMobile} alt="iOS Calendar" className="figure-image" />
                  )}
                  {isTablet && (
                    <img src={calendariOSTablet} alt="iOS Calendar" className="figure-image" />
                  )}
                  {isDesktop && (
                    <img src={calendariOSDesktop} alt="iOS Calendar" className="figure-image" />
                  )}
                  <p className="caption">iOS</p>
                </div>
                <div className="figure-item">
                  {isMobile && (
                    <img src={calendarAndroidMobile} alt="Android Calendar" className="figure-image" />
                  )}
                  {isTablet && (
                    <img src={calendarAndroidTablet} alt="Android Calendar" className="figure-image" />
                  )}
                  {isDesktop && (
                    <img src={calendarAndroidDesktop} alt="Android Calendar" className="figure-image" />
                  )}
                  <p className="caption">Android</p>
                </div>
              </div>
            </div>

            <div className="chapter-text-content">
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Arrows</span><br></br> Tap the Left or Right arrows to navigate to the previous or next day.
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Calendar Icon</span><br></br> Tap the calendar to select a specific date from a picker. The selected date's schedule will appear in the Today tab.
              </div>
            </div>
          </div>

          <div className='small-heading'>
            Footer Navigation
          </div>

          <div>
            Use the footer bar to toggle between the Schedules main screen and the Dictations management screen.
          </div>

          <div className="footer-nav-demo">
            <div className="footer-nav-item footer-nav-item--active">
              <svg className="footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <span>Schedules</span>
            </div>

            <div className="footer-nav-item">
              <svg className="footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                <line x1="12" y1="19" x2="12" y2="23"></line>
                <line x1="8" y1="23" x2="16" y2="23"></line>
              </svg>
              <span>Dictations</span>
            </div>
          </div>

          <div className='sub-chapter-heading' id="4.2">
            4.2 Schedule Status Indicators
          </div>

          <div>
            Schedule status can be identified by the colored icon located before the patient's name.
          </div>

          <div className="status-indicators">
            <div className='icon-description'>
              <div className="status-icon status-icon--new">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="#5B9AFE">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              </div>

              <div className='margin-bottom-20'>
                <span className='blue-heading'>New</span><br></br> The patient is on the schedule, but no dictation has been started.
              </div>
            </div>

            <div className='icon-description'>
              <div className="status-icon status-icon--completed">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="#73C536">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              </div>

              <div className='margin-bottom-20'>
                <span className='blue-heading'>Completed</span><br></br>All dictations have been completed and are ready to be uploaded to TransDyne.
              </div>
            </div>
          </div>

          <div className='sub-chapter-heading' id="4.3">
            4.3 Managing Schedules
          </div>

          <div className='margin-bottom-20'>
            <div className='small-heading'>
              Start a Dictation
            </div>

            <div>
              To begin recording, simply tap on any patient name displayed on your schedule.
            </div>
          </div>

          <div className="chapter-content-flex">
            <div className="chapter-text-content">
              <div className='small-heading'>
                Add a Patient (Anonymous Dictation)
              </div>
              <div className='margin-bottom-20'>
                If a patient is not on your schedule, you can add them manually using the Add (+) icon in the top-right corner.
              </div>
              <div className='margin-bottom-10'>
                <strong>1.</strong> Tap the (+) icon.
              </div>
              <div className='margin-bottom-10'>
                <strong>2.</strong> Fill in the optional First Name, Last Name, and Account Number.
                <div className='note'>
                  Note: If no Last Name is provided, the entry will appear as "Anonymous" followed by the date and time.
                </div>
              </div>
              <div className='margin-bottom-10'>
                <strong>3.</strong> Tap Submit to add the patient to your schedule and begin recording immediately.
              </div>
            </div>

            <div className="add-patient-form">
              <div className="form-title">Add new walk-in</div>
              <div className="form-field">
                <label>First Name</label>
                <div className="form-input">Doe</div>
              </div>
              <div className="form-field">
                <label>Last Name</label>
                <div className="form-input">Johnson</div>
              </div>
              <div className="form-field">
                <label>Account Number</label>
                <div className="form-input">47297365986</div>
              </div>
              <div className="form-buttons">
                <button className="btn-cancel">Cancel</button>
                <button className="btn-submit">Submit</button>
              </div>
            </div>
          </div>

          <div className='small-heading'>
            Mark as Dictated
          </div>

          <div className="chapter-content-flex">
            {isMobile && (
              <img src={markAsDictatedMobile} className="chapter-image-large" alt="Mark as Dictated" />
            )}
            {isTablet && (
              <img src={markAsDictatedTablet} className="chapter-image-large" alt="Mark as Dictated" />
            )}
            {isDesktop && (
              <img src={markAsDictatedDesktop} className="chapter-image-large" alt="Mark as Dictated" />
            )}

            <div className="chapter-text-content">
              <div className='margin-bottom-10'>
                If you need to clear a patient from your view without recording audio, you can manually mark the schedule as dictated.
              </div>
              <div className='margin-bottom-10'>
                <strong>1.</strong> Long-press on the specific patient card.
              </div>
              <div className='margin-bottom-10'>
                <strong>2.</strong> Select Mark as Dictated.
              </div>
              <div className='margin-bottom-10'>
                <strong>3.</strong> The patient will be removed from the active view.
              </div>
            </div>
          </div>
        </div>







        {/* Chapter 5 - Dictations Screen */}
        <div className="toc-container">
          

          <div className="chapter-content-flex margin-bottom-40">
            <div className="chapter-text-content">
              <div className='chapter-heading' id="chapter5">
                Chapter 5 – Dictations Screen
              </div>
              <div>
                The Dictations screen displays a comprehensive list of all your recordings, allowing you to track their completion and upload status. Access this screen by tapping Dictations in the footer of the Schedules page.
              </div>
            </div>
            {isMobile && (
              <img src={dictationScreenMobile} className="chapter-image" alt="Dictation Screen" />
            )}
            {isTablet && (
              <img src={dictationScreenTablet} className="chapter-image" alt="Dictation Screen" />
            )}
            {isDesktop && (
              <img src={dictationScreenDesktop} className="chapter-image" alt="Dictation Screen" />
            )}
          </div>

          <div className='sub-chapter-heading' id="5.1">
            5.1 Screen Navigation & Tabs
          </div>

          <div className='margin-bottom-20'>
            The Dictations menu allows you to filter your view using three specific tabs:
          </div>

          <div className='margin-bottom-20'>
            <span className='blue-heading'>Today</span><br></br> Displays all dictations for the selected date, regardless of their status. Use the calendar icon to change the date view.
          </div>
          <div className='margin-bottom-20'>
            <span className='blue-heading'>Incomplete</span><br></br> Displays only those dictations that are currently pending for the selected date.
          </div>
          <div className='margin-bottom-20'>
            <span className='blue-heading'>Complete</span><br></br> Displays only those dictations that have been completed for the selected date.
          </div>

          <div className="tabs-demo">
            <div className="tab">Today</div>
            <div className="tab">Incomplete</div>
            <div className="tab tab--active">Complete</div>
          </div>

          <div className='sub-chapter-heading' id="5.2">
            5.2 The Dictation Card
          </div>

          <div>
            Each recording is represented by a card containing key details about the file:
          </div>

          <div className="chapter-content-flex margin-top-30 margin-bottom-40">
            <div className="chapter-text-content">
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Patient Name</span><br></br> Displayed prominently at the top.
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Duration</span><br></br> The length of the recording (displayed below the name).
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Document Type</span><br></br> The report type (e.g., Discharge Summary, Letter) appears next to the duration.
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Dictation ID</span><br></br> A unique identifier shown in the top-right corner.
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Start Time</span><br></br> The local time the recording began (displayed below the ID).
              </div>
            </div>

            {isMobile && (
              <img src={dictationCardMobile} className="chapter-image-xlarge" alt="Dictation Card" />
            )}
            {isTablet && (
              <img src={dictationCardTablet} className="chapter-image-xlarge" alt="Dictation Card" />
            )}
            {isDesktop && (
              <img src={dictationCardDesktop} className="chapter-image-xlarge" alt="Dictation Card" />
            )}
          </div>

          <div className='sub-chapter-heading' id="5.3">
            5.3 Status Indicators
          </div>

          <div className='margin-bottom-20'>
            The application uses icons and border colors to indicate the state of a dictation.
          </div>

          <div className='small-heading'>
            Dictation Status
          </div>

          <div className='margin-bottom-20'>
            Look for the icon displayed on the dictation card
          </div>

          <div className="status-indicators">
            <div className='icon-description'>
              <div className="status-icon-mic status-icon-mic--completed">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5ebd3e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                  <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                  <line x1="12" y1="19" x2="12" y2="23"></line>
                </svg>
              </div>

              <div className='margin-bottom-20'>
                <span className='blue-heading'>Completed</span><br></br>The dictation is completed and is ready to be uploaded to TransDyne.
              </div>
            </div>

            <div className='icon-description'>
              <div className="status-icon-mic status-icon-mic--archived">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                  <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                  <line x1="12" y1="19" x2="12" y2="23"></line>
                </svg>
              </div>

              <div className='margin-bottom-20'>
                <span className='blue-heading'>Archived</span><br></br>The dictation has been successfully uploaded to TransDyne and archived locally.
                <div className='note'>
                  Note: Archived dictations cannot be reopened. Selecting one will display the message: "This dictation has been archived."
                </div>
              </div>
            </div>
          </div>

          <div className='small-heading'>
            Upload Status
          </div>

          <div className='margin-bottom-20'>
            Completed dictation cards use color-coded borders to show if they have reached the server
          </div>
          <div className='margin-bottom-20'>
            <span className='blue-heading'>Pending / Not Uploaded <span className="status-dot status-dot--red"></span></span><br></br>By default, completed dictations show a red border while the upload is in progress.
          </div>
          <div className='margin-bottom-20'>
            <span className='blue-heading'>Upload Successful <span className="status-dot status-dot--green"></span></span><br></br> The border turns green immediately once the file reaches the server.
          </div>
          <div className="chapter-content-flex upload-progress-banner margin-bottom-40">  
            <img src={uploadProgressBanner} className="chapter-image-large" alt="Upload Progress Banner" />          
            <div className="chapter-text-content">
              The Schedules screen displays a banner at the top of the screen when uploads are in progress. The banner shows the number of dictations currently being uploaded.
            </div>
          </div>

          <div className='sub-chapter-heading' id="5.4">
            5.4 Troubleshooting Uploads
          </div>

          <div className="chapter-content-flex-reverse margin-bottom-40">
            <div className="chapter-text-content">
              <div className='margin-bottom-20'>
                If a dictation remains with a Red Border for an extended period, it may be due to one of the following issues:
              </div>
              <div className='margin-bottom-10'>
                <strong>1.</strong> Weak or no internet connection.
              </div>
              <div className='margin-bottom-10'>
                <strong>2.</strong> The dictation exceeds the maximum supported limit (1.5 hours).
              </div>
              <div className='margin-bottom-10'>
                <strong>3.</strong> A temporary technical issue with the app.
              </div>

              <div className='note'>
                Note: If you receive an Upload Notification regarding failed uploads, tap the notification to open the app and automatically retry the process.
              </div>
            </div>

            <div className="notification-card">
              <div className="notification-header">
                <div className="notification-app-info">
                  <img src={vscribeIcon} alt="App Icon" className="notification-icon" />
                  <span>vScribe+ • now</span>
                </div>
                <span>^</span>
              </div>

              <div className="notification-content">
                <div className="notification-title">Action Required</div>
                <div className="notification-message">Tap to resume dictation uploads</div>
              </div>

              <div className="notification-buttons">
                <div className="notification-btn">Manage</div>
                <div className="notification-btn">Clear all</div>
              </div>
            </div>
          </div>

          <div className='small-heading'>
            How to Initiate a Manual Re-Upload
          </div>

          <div className="chapter-content-flex">
            {isMobile && (
              <img src={reUploadMobile} className="chapter-image-large" alt="Re-Upload" />
            )}
            {isTablet && (
              <img src={reUploadTablet} className="chapter-image-large" alt="Re-Upload" />
            )}
            {isDesktop && (
              <img src={reUploadDesktop} className="chapter-image-large" alt="Re-Upload" />
            )}

            <div className="chapter-text-content">
              <div className='margin-bottom-20'>
                If a file fails to upload automatically, force a manual retry:
              </div>

              <div className='margin-bottom-10'>
                <strong>1.</strong> Locate the dictation with the Red Border.
              </div>
              <div className='margin-bottom-10'>
                <strong>2.</strong> Long-press the dictation card to open the menu.
              </div>
              <div className='margin-bottom-10'>
                <strong>3.</strong> Select Re-Upload.
              </div>

              <div className='note'>
                If the issue persists after a manual re-upload, please contact Support.
              </div>
            </div>
          </div>
        </div>

        {/* Chapter 6 - Initiate Dictation for a Patient */}
        <div className="toc-container">
          <div className='chapter-heading' id="chapter6">
            Chapter 6 – Initiate Dictation for a Patient
          </div>

          <div className='margin-bottom-40'>
            This chapter covers how to initiate recordings for patients listed on your schedule, manage multiple reports for a single encounter, and resume pending work.
          </div>

          <div className='sub-chapter-heading' id="6.1">
            6.1 Starting a New Dictation
          </div>

          <div className='margin-bottom-20'>
            Follow these steps to begin a recording for a scheduled patient:
          </div>

          <div className='margin-bottom-30'>
            <span className='blue-heading'>1. Select Date of Service (DOS)</span><br></br>Navigate to the required date on the Schedules screen.
          </div>
          <div className='margin-bottom-30'>
            <span className='blue-heading'>2. Select Patient</span><br></br>Tap the specific patient's name.
          </div>
          <div className='margin-bottom-30'>
            <span className='blue-heading'>3. Confirm Location</span><br></br>Select the patient's visit location.
          </div>
          <div className='margin-bottom-30'>
            <span className='blue-heading'>4. Select Document Type</span><br></br>Choose the appropriate document type (e.g., Discharge Summary) from the list.
          </div>
          <div className='margin-bottom-30'>
            <span className='blue-heading'>5. Begin</span><br></br>The app will automatically open the Recording Screen and start recording. Patient details will be pre-populated.
          </div>

          <div className="workflow-images">
            {isMobile && (
              <img src={schedulesScreenMobile} className="workflow-image" alt="Schedules Screen" />
            )}
            {isTablet && (
              <img src={schedulesScreenTablet} className="workflow-image" alt="Schedules Screen" />
            )}
            {isDesktop && (
              <img src={schedulesScreenDesktop} className="workflow-image" alt="Schedules Screen" />
            )}
            {isSmallScreen ? <div className="down-arrow">&darr;</div> : <div className="flow-arrow">&rarr;</div>}
            {isMobile && (
              <img src={locationsScreenMobile} className="workflow-image" alt="Locations Screen" />
            )}
            {isTablet && (
              <img src={locationsScreenTablet} className="workflow-image" alt="Locations Screen" />
            )}
            {isDesktop && (
              <img src={locationsScreenDesktop} className="workflow-image" alt="Locations Screen" />
            )}
            {isSmallScreen ? <div className="down-arrow">&darr;</div> : <div className="flow-arrow">&rarr;</div>}
            {isMobile && (
              <img src={documentTypeMobile} className="workflow-image" alt="Document Type Screen" />
            )}
            {isTablet && (
              <img src={documentTypeTablet} className="workflow-image" alt="Document Type Screen" />
            )}
            {isDesktop && (
              <img src={documentTypeDesktop} className="workflow-image" alt="Document Type Screen" />
            )}
            {isSmallScreen ? <div className="down-arrow">&darr;</div> : <div className="flow-arrow">&rarr;</div>}
            {isMobile && (
              <img src={recordScreenDscribeMobile} className="workflow-image" alt="Record Screen" />
            )}
            {isTablet && (
              <img src={recordScreenDscribeTablet} className="workflow-image" alt="Record Screen" />
            )}
            {isDesktop && (
              <img src={recordScreenDscribeDesktop} className="workflow-image" alt="Record Screen" />
            )}
          </div>

          <div className='sub-chapter-heading' id="6.2">
            6.2 Creating Additional Dictations
          </div>

          <div>
            Follow these steps to record additional dictations for a single patient encounter:
          </div>

          <div className='margin-bottom-10'>
            <strong>1.</strong> Tap the patient's name to view their Dictation History.
            <div className="status-legend">
              <span className="status-dot status-dot--green"></span>
              <strong>Green Status:</strong> Indicates Finalized/Complete dictations.
            </div>
            
          </div>
          <div className='margin-bottom-10'>
            <strong>2.</strong> To start a fresh recording, simply select a New Document Type from the list.
          </div>
          <div className='margin-bottom-10'>
            <strong>3.</strong> Recording will begin immediately with the patient's details automatically attached.
          </div>

          <div className="workflow-images-simple">
            {isMobile && (
              <img src={schedulesScreenMobile} className="workflow-image" alt="Schedules Screen" />
            )}
            {isTablet && (
              <img src={schedulesScreenTablet} className="workflow-image" alt="Schedules Screen" />
            )}
            {isDesktop && (
              <img src={schedulesScreenDesktop} className="workflow-image" alt="Schedules Screen" />
            )}
            {isSmallScreen ? <div className="down-arrow">&darr;</div> : <div className="flow-arrow">&rarr;</div>}
            {isMobile && (
              <img src={documentTypeDictationsMobile} className="workflow-image" alt="Document Type Screen" />
            )}
            {isTablet && (
              <img src={documentTypeDictationsTablet} className="workflow-image" alt="Document Type Screen" />
            )}
            {isDesktop && (
              <img src={documentTypeDictationsDesktop} className="workflow-image" alt="Document Type Screen" />
            )}
          </div>

          <div className='sub-chapter-heading' id="6.3">
            6.3 Appending to a Dictation
          </div>

          <div className="chapter-content-flex">
            <div className="chapter-text-content">
              <div className='small-heading'>Add to a Completed Dictation</div>
              <div className='margin-bottom-10'>If a dictation is marked Complete but requires more information (Addendum)</div>
              <div className='margin-bottom-10'>
                <strong>1.</strong> Tap the completed dictation to open the Playback Screen.
              </div>
              <div className='margin-bottom-10'>
                <strong>2.</strong> Tap the Add Addendum button in the top-right corner.
              </div>
              <div className='margin-bottom-10'>
                <strong>3.</strong> The app will redirect you to the recording screen, allowing you to append supplementary audio to the end of the existing file.
              </div>
            </div>

            {isMobile && (
              <img src={playScreenMobile} className="chapter-image" alt="Playback Screen" />
            )}
            {isTablet && (
              <img src={playScreenTablet} className="chapter-image" alt="Playback Screen" />
            )}
            {isDesktop && (
              <img src={playScreenDesktop} className="chapter-image" alt="Playback Screen" />
            )}
          </div>
        </div>

        {/* Chapter 7 - Recording Screen */}
        <div className="toc-container">
          <div className="chapter-content-flex margin-bottom-40">
            <div className="chapter-text-content">
              <div className='chapter-heading' id="chapter7">
                Chapter 7 – Recording Screen
              </div>
              <div>
                The Recording Screen is the primary interface for capturing dictations. It displays essential patient demographics, audio visualization, and a comprehensive set of controls for recording and reviewing your audio.
              </div>
            </div>

            {isMobile && (
              <img src={recordScreenDscribeMobile} className="chapter-image" alt="Recording Screen" />
            )}
            {isTablet && (
              <img src={recordScreenDscribeTablet} className="chapter-image" alt="Recording Screen" />
            )}
            {isDesktop && (
              <img src={recordScreenDscribeDesktop} className="chapter-image" alt="Recording Screen" />
            )}
          </div>

          <div className='sub-chapter-heading' id="7.1">
            7.1 Patient Identification Card
          </div>

          <div className='margin-bottom-30'>
            Located at the top of the screen, this card displays essential patient demographics to ensure you are dictating for the correct individual.
          </div>

          <div className="chapter-content-flex margin-bottom-20">
            <div className="patient-card">
              <div className="patient-name">Cruz Ariaz</div>
              <div className="patient-details">
                <div><strong>Account No:</strong> 1000004</div>
                <div><strong>Date of Service:</strong> 10/23/2025</div>
                <div><strong>Date of Birth:</strong> 2/28/1961</div>
                <div><strong>Appt Type:</strong> CONSULT</div>
                <div><strong>Visit Reason:</strong> FOV JTP Mid</div>
              </div>
            </div>

            <ol className='blue-list'>
              <li>Patient Name</li>
              <li>Account No</li>
              <li>Date of Service</li>
              <li>Date of Birth</li>
              <li>Appointment Type</li>
              <li>Visit Reason</li>
            </ol>
          </div>

          <div className='sub-chapter-heading' id="7.2">7.2 Audio Controls</div>

          <div className='small-heading'>Recording Actions</div>
          <div className='icon-description-list'>
            <div className='icon-description-item'>
              <div className='audio-control-icon'>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
                  <circle cx="18" cy="18" r="17" stroke='#5B9AFE' strokeWidth="1.5" />
                  <circle cx="18" cy="18" r="9" fill='#5B9AFE' />
                </svg>
              </div>
              <div className='margin-top-8'>
                <span className='icon-heading'>Record:</span> Tap to begin capturing audio.
              </div>
            </div>

            <div className='icon-description-item'>
              <div className='audio-control-icon'>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
                  <circle cx="18" cy="18" r="17" stroke='#5B9AFE' strokeWidth="1.5" />
                  <rect x="13" y="11" width="4" height="14" rx="1" fill='#5B9AFE' />
                  <rect x="19" y="11" width="4" height="14" rx="1" fill='#5B9AFE' />
                </svg>
              </div>
              <div className='margin-top-8'>
                <span className='icon-heading'>Pause:</span> Tap during a recording to pause the session.
              </div>
            </div>

            <div className='icon-description-item'>
              <div className='audio-control-icon audio-control-icon--text'>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                </svg>
                <span className="control-label">Overwrite</span>
              </div>
              <div className='margin-top-8'>
                <span className='icon-heading'>Overwrite:</span> Tap to record over (erase and replace) a specific section of the existing audio.
              </div>
            </div>

            <div className='icon-description-item'>
              <div className='audio-control-icon audio-control-icon--text'>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                </svg>
                <span className="control-label">Insert</span>
              </div>
              <div className='margin-top-8'>
                <span className='icon-heading'>Insert:</span> While in playback mode, use this to insert new audio at a specific timestamp without deleting existing content.
              </div>
            </div>

            <div className='icon-description-item'>
              <div className='audio-control-icon audio-control-icon--text'>
                <div className="toggle-switch">
                  <div className="toggle-circle"></div>
                </div>
                <span className="control-label">STAT</span>
              </div>
              <div className='margin-top-8'>
                <span className='icon-heading'>STAT (Priority):</span> Toggle this switch to flag the dictation as High Priority (STAT) for expedited processing by the transcription team.
              </div>
            </div>
          </div>

          <div className='small-heading'>Playback & Navigation</div>
          <div className='icon-description-list'>
            <div className='icon-description-item'>
              <div className='playback-icon'>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="#000">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
              <div className='margin-top-8'>
                <span className='icon-heading'>Play:</span> Start/Resume the playback of your recorded audio.
              </div>
            </div>

            <div className='icon-description-item'>
              <div className='playback-icon'>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="#000">
                  <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                </svg>
              </div>
              <div className='margin-top-8'>
                <span className='icon-heading'>Pause:</span> Pause the playback of your recorded audio.
              </div>
            </div>

            <div className='icon-description-item'>
              <div className='playback-icon'>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                  <path d="M3 3v5h5" />
                  <text x="12" y="16" textAnchor="middle" fontSize="8" fill="#666" stroke="none" fontFamily="Arial">10</text>
                </svg>
              </div>
              <div className='margin-top-8'>
                <span className='icon-heading'>Rewind (10s):</span> Jump back 10 seconds to review the immediate context.
              </div>
            </div>

            <div className='icon-description-item'>
              <div className='playback-icon'>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="19 20 9 12 19 4 19 20"></polygon>
                  <line x1="5" y1="19" x2="5" y2="5"></line>
                </svg>
              </div>
              <div className='margin-top-8'>
                <span className='icon-heading'>Rewind to Start:</span> Jump immediately to the beginning of the recording.
              </div>
            </div>

            <div className='icon-description-item'>
              <div className='playback-icon'>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 12a9 9 0 1 1-9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
                  <path d="M21 3v5h-5" />
                  <text x="12" y="16" textAnchor="middle" fontSize="8" fill="#666" stroke="none" fontFamily="Arial">10</text>
                </svg>
              </div>
              <div className='margin-top-8'>
                <span className='icon-heading'>Fast Forward (10s):</span> Skip forward 10 seconds.
              </div>
            </div>

            <div className='icon-description-item'>
              <div className='playback-icon'>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="5 4 15 12 5 20 5 4"></polygon>
                  <line x1="19" y1="5" x2="19" y2="19"></line>
                </svg>
              </div>
              <div className='margin-top-8'>
                <span className='icon-heading'>Fast Forward to End:</span> Jump immediately to the end of the recording.
              </div>
            </div>
          </div>

          <div className='small-heading'>Audio Output</div>
          <div className='icon-description-list'>
            <div className='icon-description-item'>
              <div className="speaker-control">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5B9AFE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                  <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                  <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
                </svg>
                <span className="control-label-small">Speaker</span>
              </div>
              <div>
                <span className='icon-heading'>Speaker/Ear Mode:</span> Tap to toggle audio output between the phone's main speaker (Speakerphone) and the earpiece receiver (Privacy mode).
              </div>
            </div>
          </div>

          <div className='sub-chapter-heading' id="7.3">7.3 Finalizing the Dictation</div>
          <div>
            Once you have finished recording, you must choose a status for the file
          </div>
          <div className='icon-description-list margin-bottom-40'>
            <div className='icon-description-item'>
              <div className="action-button action-button--complete">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="3" width="18" height="18" rx="5" ry="5"></rect>
                  <polyline points="9 11 12 14 16 9"></polyline>
                </svg>
                Complete
              </div>
              <div className='margin-top-8'>
                <span className='icon-heading'>Complete:</span> Tap this when the dictation is finished and ready for upload to TransDyne.
              </div>
            </div>
            <div className='icon-description-item'>
              <div className="action-button action-button--abort">
                Abort
              </div>
              <div className='margin-top-8'>
                <span className='icon-heading'>Abort:</span> Tap this if you need to discard the current recording and return to the Schedules screen without saving any audio.
              </div>
            </div>
          </div>

          <div className='sub-chapter-heading margin-top-40' id="7.4">7.4 Lite Mode</div>
          <div className="chapter-content-flex margin-bottom-40">
            <div className="chapter-text-content">
              
              <div>
                Lite Mode is a simplified interface designed for users who prefer a more streamlined experience. In Lite Mode, the application focuses on essential features, reducing visual clutter and making it easier to navigate.
              </div>

              <div className='small-heading'>Patient Identification Card</div>
              <div className='margin-bottom-30'>
                Patient details are displayed in a compact card format showing only the Account Number, ensuring that you can quickly verify the patient's information before starting your dictation.
              </div>

              <div className='small-heading'>Recording Actions</div>
              <div className='margin-bottom-30'>
                It only displays the Record, Pause and Stat buttons, allowing you to focus solely on capturing your dictation without additional distractions.
              </div>

              <div className='small-heading'>Playback & Navigation</div>
              <div className='margin-bottom-30'>
                It only displays the Play and Pause buttons, along with the Rewind and Fast Forward controls, providing a straightforward way to review your recordings.
              </div>

              <div className='small-heading'>Finalizing the Dictation</div>
              <div className='margin-bottom-30'>
                Lite Mode only provides the Complete button, allowing you to quickly finalize your dictation without additional options.
              </div>

            </div>
            {isMobile && (   
              <img src={dscribeLiteModeMobile} className="chapter-image" alt="Recording Screen Lite Mode" />
            )}
            {isTablet && (
              <img src={dscribeLiteModeTablet} className="chapter-image" alt="Recording Screen Lite Mode" />
            )}
            {isDesktop && (
              <img src={dscribeLiteModeDesktop} className="chapter-image" alt="Recording Screen Lite Mode" />
            )}
          </div>
          
        </div>

        {/* Chapter 8 – Settings */}
        <div className="toc-container">
          <div className="chapter-content-flex">
            <div className="chapter-text-content">
              <div className='chapter-heading' id="chapter8">
                Chapter 8 – Settings
              </div>
              <div className='margin-bottom-30'>
                The settings menu is used to configure the application. You can access this screen by selecting the Settings option from the application menu.
              </div>
            </div>
          </div>

          <div className="chapter-content-flex">
            <div className="chapter-text-content">
              <div className='sub-chapter-heading' id="8.1">
                8.1 Configurations
              </div>

              <div className='margin-bottom-20'>The following configuration options are available within the application:</div>

              <div className='margin-bottom-20'>
                <span className='blue-heading'>Upload Logs to TransDyne</span><br></br>Tap "Upload Logs" to send application log files to TransDyne servers.
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Schedules Sync Frequency</span><br></br>Configure how often schedules are synchronized with the server (default: every 30 minutes).
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Reset Last Sync Time</span><br></br>Tap "Sync" to initiate a full data synchronization from the server.
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Purge Recordings After</span><br></br>Set the number of days after which dictations are automatically archived.
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Max Storage</span><br></br>Configure the maximum storage space for the application. When this limit is reached, dictations are automatically archived.
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Name Format</span><br></br>Select the preferred format for displaying patient names (e.g., First Last or Last, First).
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Sort By</span><br></br>Configure the schedule sort order. Sort schedules by Earliest First, Latest First, Last Name (A-Z), or Last Name (Z-A).
              </div>
              <div className='margin-bottom-40'>
                <span className='blue-heading'>Lite Mode</span><br></br>Enable or disable Lite Mode, which is a simplified interface design for users who prefer a more streamlined experience.
              </div>

              <div className='sub-chapter-heading margin-bottom-30' id="8.2">
                8.2 Additional Information
              </div>

              <div className='margin-bottom-20'>
                <span className='blue-heading'>App Version</span><br></br>Displays the currently installed application version.
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>Phone</span><br></br>Provides the contact number for Support assistance.
              </div>
              <div className='margin-bottom-40'>
                <span className='blue-heading'>Email</span><br></br>Provides the Support email address for queries or assistance.
              </div>
            </div>

            {isMobile && (
              <img src={settingsScreenMobile} className="settings-image" alt="Settings Screen" />
            )}
            {isTablet && (
              <img src={settingsScreenTablet} className="settings-image" alt="Settings Screen" />
            )}
            {isDesktop && (
              <img src={settingsScreenDesktop} className="settings-image" alt="Settings Screen" />
            )}
          </div>
        </div>

        {/* Chapter 9 – Logging Out */}
        <div className="toc-container">
          <div className="chapter-content-flex">
            <div className="chapter-text-content">
              <div className='chapter-heading' id="chapter9">
                Chapter 9 – Logging Out
              </div>
              <div>
                To ensure the security of your patient data, it is recommended to log out of the application when you are finished using it.
              </div>
              
              <div className='small-heading'>How to Log Out</div>
              <div className='margin-bottom-20'>You can initiate the logout process from two locations:</div>

              <div className='margin-bottom-20'>
                <span className='blue-heading'>From Settings</span><br></br>Navigate to the Settings page and select the Logout option.
              </div>
              <div className='margin-bottom-20'>
                <span className='blue-heading'>From the Application Menu</span><br></br>Open the main Application Menu and tap Logout.
              </div>

              <div className='small-heading margin-bottom-20'>Returning to the Login Screen</div>
              <div className='margin-bottom-10'><strong>1.</strong> Upon logging out, you will be redirected to the Logout confirmation page.</div>
              <div className='margin-bottom-10'><strong>2.</strong> To return to the main Login Page (to sign in as a different user or log back in), tap the Cancel button in the top-left corner.</div>
            </div>

            {isMobile && (
              <img src={logoutScreenMobile} className="logout-image" alt="Logout Screen" />
            )}
            {isTablet && (
              <img src={logoutScreenTablet} className="logout-image" alt="Logout Screen" />
            )}
            {isDesktop && (
              <img src={logoutScreenDesktop} className="logout-image" alt="Logout Screen" />
            )}
          </div>
        </div>

      </div>
    </div>
  </Layout>  
  );
};

export default DscribeGuide;